import "../scss/main.scss";
import "bootstrap";
import anime from "animejs/lib/anime.es";
import iziToast from "izitoast";
import jquery from "jquery";
import lazySizes from "lazysizes";
import { Atropos } from "atropos";
import Prism from "prismjs";
import { tsParticles } from "tsparticles-engine";
import { loadSlim } from "tsparticles-slim";

const lintHelper = {
  lazySizes: lazySizes,
};

const $ = jquery;

// Copy to clipboard handler
function copyToClipboard(event: {
  currentTarget: any;
  preventDefault: () => void;
}) {
  event.preventDefault();
  const el = document.createElement("textarea");
  el.value = event.currentTarget.dataset.textToCopy!;
  document.body.appendChild(el);
  el.select();
  document.execCommand("copy");
  document.body.removeChild(el);

  iziToast.show({
    message: "Copied to clipboard!",
    position: "bottomRight",
    backgroundColor: "#002b36",
    progressBar: false,
    messageColor: "white",
    titleColor: "white",
    transitionIn: "bounceInDown",
    transitionOut: "fadeOutUp",
    theme: "dark",
    timeout: 2500,
  });
}

document.addEventListener(
  "DOMContentLoaded",
  function () {
    Prism.highlightAll();
    document.querySelectorAll(".para-effect").forEach((element: any) => {
      Atropos({
        el: element,
        rotateTouch: false,
        shadowScale: 0.8,
      });
    });
    $(".copy-to-clipboard").each(function () {
      $(this).on("click", copyToClipboard);
    });

    // Navbar handler
    $(".mobile-nav-toggle").each(function () {
      if ($(this).attr("data-state")) {
        $(this).click(function () {
          if ($(this).attr("data-state") === "collapsed") {
            $($("body")[0]).css("overflow", "unset");
            $(this).removeClass("active");
            $(this).attr("data-state", "hidden");
            $(".mobile-nav-overlay")[0].style.height = "0%";
            setTimeout(function () {
              $(".mobile-nav-overlay__content").hide();
            }, 500);
          } else {
            $(".mobile-nav-overlay__content").show();
            $($("body")[0]).css("overflow", "hidden");
            $(this).addClass("active");
            $(this).attr("data-state", "collapsed");
            $(".mobile-nav-overlay")[0].style.height = "120%";
          }
        });
      }
    });
    // Navbar handler accessibility
    $(".mobile-nav-toggle").keypress(function (e) {
      if (+e.key === 13) {
        if ($(this).attr("data-state")) {
          $(this).click(function () {
            if ($(this).attr("data-state") === "collapsed") {
              $($("body")[0]).css("overflow", "unset");
              $(this).removeClass("active");
              $(this).attr("data-state", "hidden");
              $(".mobile-nav-overlay")[0].style.height = "0%";
              setTimeout(function () {
                $(".mobile-nav-overlay__content").hide();
              }, 500);
              $(".mobile-nav-toggle").focus();
            } else {
              $(".mobile-nav-overlay__content").show();
              $(".mobile-nav-overlay__content").focus();
              $($("body")[0]).css("overflow", "hidden");
              $(this).addClass("active");
              $(this).attr("data-state", "collapsed");
              $(".mobile-nav-overlay")[0].style.height = "120%";
            }
          });
        }
      }
    });
    // Escape key makes navbar dissapear
    $(document).keyup(function (e) {
      if (e.key === "Escape") {
        $($("body")[0]).css("overflow", "unset");
        $($(".mobile-nav-toggle")[0]).removeClass("active");
        $($(".mobile-nav-toggle")[0]).attr("data-state", "hidden");
        $(".mobile-nav-overlay")[0].style.height = "0%";
      }
    });
    // Navbar handler
    const currentmode = window.localStorage.getItem("displayMode")
      ? window.localStorage.getItem("displayMode")
      : "dark";
    $(".display-mode-toggle").first().data("currentMode", currentmode);
    $(".display-mode-toggle").each(function () {
      if ($(this).attr("data-current-mode")) {
        $(this).click(function () {
          if ($(this).attr("data-current-mode") === "dark") {
            $(this).attr("data-current-mode", "light");
            $(this).html(
              '<svg class="light-color-fill" width="35" viewBox="0 0 50 50" preserveAspectRatio="xMidYMid meet"><use xlink:href="#icon-night-50x50"></use></svg>'
            );
            window.localStorage.setItem("displayMode", "light");
            document.cookie = "display_mode=light; path=/";
            location.reload();
          } else {
            $(this).attr("data-current-mode", "dark");
            $(this).html(
              '<svg class="light-color-fill" width="35" viewBox="0 0 50 50" preserveAspectRatio="xMidYMid meet"><use xlink:href="#icon-day-50x50"></use></svg>'
            );
            window.localStorage.setItem("displayMode", "dark");
            document.cookie = "display_mode=dark; path=/";
            location.reload();
          }
        });
      }
    });
    if (typeof anime !== "undefined") {
      anime({
        targets: ".ismailzai-bulb-logo--fillament__center",
        strokeDashoffset: [anime.setDashoffset, 0],
        easing: "easeInOutSine",
        duration: 5000,
        delay: function (el: any, i: number) {
          return i * 250;
        },
        direction: "alternate",
        loop: true,
      });
      anime({
        targets: ".ismailzai-bulb-logo--metal path",
        strokeDashoffset: [anime.setDashoffset, 0],
        easing: "easeInOutSine",
        duration: 1500,
        delay: function (el: any, i: number) {
          return i * 250;
        },
        direction: "alternate",
        loop: false,
      });
      anime({
        targets: ".ismailzai-bulb-logo--glass path",
        strokeDashoffset: [anime.setDashoffset, 0],
        easing: "easeInOutSine",
        duration: 1500,
        delay: function (el: any, i: number) {
          return i * 250;
        },
        direction: "alternate",
        loop: false,
      });
      anime({
        targets: ".ismailzai-bulb-logo--glass__bracketLeft",
        translateX: -25,
        direction: "alternate",
        loop: 1,
      });
      anime({
        targets: ".ismailzai-bulb-logo--glass__bracketRight",
        translateX: 25,
        direction: "alternate",
        loop: 1,
      });
    }
  },
  false
);

const hasLinksParticles = document.body.classList.contains(
  "hasLinksParticlesXXXXXXXXXXXXXXXXXX"
);
if (hasLinksParticles) {
  (async () => {
    await loadSlim(tsParticles);
    await tsParticles.load("tsparticles", {
      fpsLimit: 60,
      particles: {
        links: {
          color: "#ffffff",
          distance: 150,
          enable: true,
          opacity: 0.5,
          width: 1,
        },
        move: {
          enable: true,
          outModes: {
            default: "bounce",
          },
          speed: 2,
        },
        number: {
          density: {
            enable: true,
          },
          value: 30,
        },
        opacity: {
          value: 0.5,
        },
        shape: {
          type: "triangle",
        },
        size: {
          value: { min: 1, max: 5 },
        },
      },
      detectRetina: true,
    });
  })();
}
